function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.5em;\n  margin-bottom: 0.8em;\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n  line-height: 1.3;\n  font-size: calc(var(--markdown-base-size, 1em) * 2);\n  position: relative;\n  padding-left: var(--theme-spacing-sm, 0.5rem);\n  margin-left: calc(-1 * var(--theme-spacing-sm, 0.5rem));\n  border-left: 3px solid transparent;\n  transition: border-color var(--theme-transition-fast, 0.2s) ease-in-out;\n\n  &:hover {\n    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light, #0066cc));\n  }\n\n  @media (min-width: var(--theme-breakpoints-lg, 1024px)) {\n    font-size: var(--theme-typography-font-size-lg, 1.5em);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.5em;\n  margin-bottom: 0.8em;\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n  line-height: 1.3;\n  font-size: calc(var(--markdown-base-size, 1em) * 1.5);\n  position: relative;\n  padding-left: var(--theme-spacing-sm, 0.5rem);\n  margin-left: calc(-1 * var(--theme-spacing-sm, 0.5rem));\n  border-left: 3px solid transparent;\n  transition: border-color var(--theme-transition-fast, 0.2s) ease-in-out;\n\n  &:hover {\n    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light, #0066cc));\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.5em;\n  margin-bottom: 0.8em;\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n  line-height: 1.3;\n  font-size: calc(var(--markdown-base-size, 1em) * 1.25);\n  position: relative;\n  padding-left: var(--theme-spacing-sm, 0.5rem);\n  margin-left: calc(-1 * var(--theme-spacing-sm, 0.5rem));\n  border-left: 3px solid transparent;\n  transition: border-color var(--theme-transition-fast, 0.2s) ease-in-out;\n\n  &:hover {\n    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light, #0066cc));\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1em;\n  font-size: var(--markdown-base-size, 1em);\n  line-height: 1.6;\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n  position: relative;\n  padding-left: var(--theme-spacing-sm, 0.5rem);\n  margin-left: calc(-1 * var(--theme-spacing-sm, 0.5rem));\n  border-left: 3px solid transparent;\n  transition: border-color var(--theme-transition-fast, 0.2s) ease-in-out;\n\n  &:hover {\n    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light, #0066cc));\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1em;\n  padding-left: 1.5em;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1em;\n  padding-left: 1.5em;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  font-size: var(--markdown-base-size, 1em);\n  margin-bottom: 0.5em;\n  line-height: 1.6;\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  border-left: 4px solid var(--vscode-textSeparator-foreground, var(--theme-border, #ddd));\n  padding-left: var(--theme-spacing-md, 1rem);\n  margin: 1em 0;\n  color: var(--vscode-descriptionForeground, var(--theme-text-secondary, #666));\n  background-color: var(--vscode-textBlockQuote-background, transparent);\n  font-size: var(--markdown-base-size, 1em);\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 1em;\n  font-size: var(--markdown-base-size, 1em);\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border, #ddd));\n  padding: var(--theme-spacing-xs, 0.5rem) var(--theme-spacing-sm, 1rem);\n  text-align: left;\n  background-color: var(--vscode-editorWidget-background, var(--theme-paper-light, #f5f5f5));\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editorWidget-foreground, var(--theme-text, #333));\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border, #ddd));\n  padding: var(--theme-spacing-xs, 0.5rem) var(--theme-spacing-sm, 1rem);\n  text-align: left;\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  margin: 1.5em 0;\n  padding: 1rem;\n  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border, #ddd));\n  border-radius: 8px;\n  background-color: var(--vscode-editorWidget-background, var(--theme-paper-light, #f9f9f9));\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  margin: 1em 0;\n  border-radius: 4px;\n  overflow: hidden;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  line-height: 1.6;\n  color: var(--vscode-editor-foreground, var(--theme-text, #333));\n  ",
        "\n\n  a {\n    color: var(--vscode-textLink-foreground, var(--theme-primary, #0066cc));\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  hr {\n    border: 0;\n    height: 1px;\n    background-color: var(--vscode-textSeparator-foreground, var(--theme-border, #ddd));\n    margin: 1.5em 0;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useMemo } from 'react';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeReact from 'rehype-react';
import rehypeRaw from 'rehype-raw';
import remarkDirective from 'remark-directive';
import styled from '@emotion/styled';
import { Fragment } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import VideoPlayer from '../VideoPlayer';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';
// Import shared components (these should be available in shared-ui-content)
import { CustomCodeBlock } from '../CustomCodeBlock';
import TerminalCodeBlock from '../TerminalCodeBlock/TerminalCodeBlock';
import PracticeBlock from '../PracticeBlock/PracticeBlock';
import HtmlComponent from '../HtmlComponent/HtmlComponent';
import AuthenticatedImage from '../AuthenticatedImage/AuthenticatedImage';
// Import the actual video plugin from shared layer (FSD compliant)
import remarkVideoPlugin from '../../lib/remark-plugins/remark-video-plugin';
// Debug: Check if plugin is imported correctly
console.log('🔍 [MarkdownRenderer] remarkVideoPlugin imported:', {
    plugin: remarkVideoPlugin,
    type: typeof remarkVideoPlugin === "undefined" ? "undefined" : _type_of(remarkVideoPlugin),
    isFunction: typeof remarkVideoPlugin === 'function'
});
// VSCode 테마 지원을 포함한 고급 스타일 컴포넌트들
var StyledMarkdownH1 = styled.h1(_templateObject());
var StyledMarkdownH2 = styled.h2(_templateObject1());
var StyledMarkdownH3 = styled.h3(_templateObject2());
var StyledMarkdownP = styled.p(_templateObject3());
var StyledUl = styled.ul(_templateObject4());
var StyledOl = styled.ol(_templateObject5());
var StyledLi = styled.li(_templateObject6());
var StyledBlockquote = styled.blockquote(_templateObject7());
var StyledTable = styled.table(_templateObject8());
var StyledTh = styled.th(_templateObject9());
var StyledTd = styled.td(_templateObject10());
var QuizWrapper = styled.div(_templateObject11());
var CodeBlockWrapper = styled.div(_templateObject12());
// 메인 래퍼 - style prop 지원 추가
var MarkdownWrapper = styled.div(_templateObject13(), function(props) {
    return props.customFontSize ? "--markdown-base-size: ".concat(props.customFontSize, ";") : '';
});
// 추가 플러그인들 (동적 import로 optional 로드)
var loadOptionalPlugins = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var _ref, quizPlugin, practicePlugin, htmlPlugin, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all([
                            import('../../lib/remark-plugins/remark-quiz-plugin').catch(function() {
                                return null;
                            }),
                            import('../../lib/remark-plugins/remark-practice-plugin').catch(function() {
                                return null;
                            }),
                            import('../../lib/remark-plugins/remark-html-plugin').catch(function() {
                                return null;
                            })
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), quizPlugin = _ref[0], practicePlugin = _ref[1], htmlPlugin = _ref[2];
                    return [
                        2,
                        {
                            quizPlugin: quizPlugin,
                            practicePlugin: practicePlugin,
                            htmlPlugin: htmlPlugin
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            quizPlugin: null,
                            practicePlugin: null,
                            htmlPlugin: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadOptionalPlugins() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * MarkdownRenderer - 마크다운 콘텐츠를 React 컴포넌트로 렌더링
 *
 * @param markdown - 렌더링할 마크다운 문자열
 * @param className - 추가 CSS 클래스명
 * @param onQuizSubmit - 퀴즈 제출 핸들러 (optional)
 */ var MarkdownRenderer = function(param) {
    var markdown = param.markdown, content = param.content, className = param.className, onQuizSubmit = param.onQuizSubmit, _param_enableCodeHighlight = param.enableCodeHighlight, enableCodeHighlight = _param_enableCodeHighlight === void 0 ? true : _param_enableCodeHighlight, testId = param.testId, fontSize = param.fontSize, style = param.style;
    // Use content if markdown is not provided (for compatibility)
    var markdownContent = markdown || content || '';
    var processor = useMemo(function() {
        var componentMap = {
            // VSCode 테마 지원 스타일 컴포넌트들
            h1: function(props) {
                return /*#__PURE__*/ React.createElement(StyledMarkdownH1, props);
            },
            h2: function(props) {
                return /*#__PURE__*/ React.createElement(StyledMarkdownH2, props);
            },
            h3: function(props) {
                return /*#__PURE__*/ React.createElement(StyledMarkdownH3, props);
            },
            h4: 'h4',
            h5: 'h5',
            h6: 'h6',
            p: function(props) {
                return /*#__PURE__*/ React.createElement(StyledMarkdownP, props);
            },
            ul: function(props) {
                return /*#__PURE__*/ React.createElement(StyledUl, props);
            },
            ol: function(props) {
                return /*#__PURE__*/ React.createElement(StyledOl, props);
            },
            li: function(props) {
                return /*#__PURE__*/ React.createElement(StyledLi, props);
            },
            blockquote: function(props) {
                return /*#__PURE__*/ React.createElement(StyledBlockquote, props);
            },
            table: function(props) {
                return /*#__PURE__*/ React.createElement(StyledTable, props);
            },
            thead: 'thead',
            tbody: 'tbody',
            tr: 'tr',
            th: function(props) {
                return /*#__PURE__*/ React.createElement(StyledTh, props);
            },
            td: function(props) {
                return /*#__PURE__*/ React.createElement(StyledTd, props);
            },
            strong: 'strong',
            em: 'em',
            del: 'del',
            a: 'a',
            img: function(props) {
                // Use AuthenticatedImage for ugot.uk images that require authentication
                if (props.src && (props.src.includes('ugot.uk') || props.src.includes('api.ugot.uk'))) {
                    return /*#__PURE__*/ React.createElement(AuthenticatedImage, props);
                }
                // Use regular img tag for external images
                return /*#__PURE__*/ React.createElement("img", _object_spread_props(_object_spread({}, props), {
                    style: {
                        maxWidth: '100%',
                        height: 'auto'
                    }
                }));
            },
            hr: 'hr',
            br: 'br',
            // 고급 코드 블록 지원
            code: function(_param) {
                var className = _param.className, children = _param.children, props = _object_without_properties(_param, [
                    "className",
                    "children"
                ]);
                var match = /language-(\w+)/.exec(className || '');
                var language = match ? match[1] : null;
                var isTerminal = className === null || className === void 0 ? void 0 : className.includes('language-terminal');
                var isInline = !match;
                if (isInline) {
                    return /*#__PURE__*/ React.createElement("code", _object_spread({
                        style: {
                            backgroundColor: 'var(--vscode-textCodeBlock-background, #f5f5f5)',
                            color: 'var(--vscode-textPreformat-foreground, inherit)',
                            padding: '0.2em 0.4em',
                            borderRadius: '3px',
                            fontSize: '0.9em',
                            fontFamily: 'var(--vscode-editor-font-family, monospace)'
                        }
                    }, props), children);
                }
                // Try to use enhanced code blocks if available
                if (isTerminal && typeof TerminalCodeBlock !== 'undefined') {
                    return /*#__PURE__*/ React.createElement(CodeBlockWrapper, null, /*#__PURE__*/ React.createElement(TerminalCodeBlock, _object_spread({
                        code: String(children).replace(/\n$/, ''),
                        language: language
                    }, props)));
                }
                if (typeof CustomCodeBlock !== 'undefined') {
                    return /*#__PURE__*/ React.createElement(CodeBlockWrapper, null, /*#__PURE__*/ React.createElement(CustomCodeBlock, _object_spread({
                        code: String(children).replace(/\n$/, ''),
                        language: language || 'tsx'
                    }, props)));
                }
                // Fallback to syntax highlighter
                return /*#__PURE__*/ React.createElement(SyntaxHighlighter, _object_spread({
                    style: tomorrow,
                    language: language || 'text',
                    PreTag: "div"
                }, props), String(children).replace(/\n$/, ''));
            },
            pre: function(_param) {
                var children = _param.children, props = _object_without_properties(_param, [
                    "children"
                ]);
                return children;
            },
            // 고급 컴포넌트 지원
            'video-player': function(props) {
                var src = props.src, title = props.title, poster = props.poster, isHLS = props.isHLS, children = props.children, rest = _object_without_properties(props, [
                    "src",
                    "title",
                    "poster",
                    "isHLS",
                    "children"
                ]);
                console.log('🎬 MarkdownRenderer video-player props:', {
                    src: src,
                    title: title,
                    isHLS: isHLS,
                    children: children ? 'has children' : 'no children',
                    allProps: props
                });
                // children에서 src 추출 시도 (directive 파싱 문제 대응)
                var actualSrc = src;
                if (!actualSrc && children && typeof children === 'string') {
                    var srcMatch = children.match(/src="([^"]+)"/);
                    if (srcMatch) {
                        actualSrc = srcMatch[1];
                        console.log('🎬 Extracted src from children:', actualSrc);
                    }
                }
                return /*#__PURE__*/ React.createElement(VideoPlayer, _object_spread({
                    src: actualSrc,
                    title: title,
                    poster: poster
                }, rest));
            },
            'interactive-quiz': function(props) {
                // 퀴즈 기능은 course feature에서 제공해야 하므로 shared layer에서는 기본 렌더링만
                return /*#__PURE__*/ React.createElement(QuizWrapper, null, /*#__PURE__*/ React.createElement("div", null, "퀴즈 컴포넌트 (Course Feature에서 제공): ", JSON.stringify(props)));
            },
            'practice-block': function(props) {
                if (typeof PracticeBlock !== 'undefined') {
                    return /*#__PURE__*/ React.createElement(PracticeBlock, props);
                }
                return /*#__PURE__*/ React.createElement("div", null, "연습 블록: ", JSON.stringify(props));
            },
            'html-component': function(props) {
                if (typeof HtmlComponent !== 'undefined') {
                    var children = props.children, rest = _object_without_properties(props, [
                        "children"
                    ]);
                    var htmlContent = typeof children === 'string' ? children : React.Children.toArray(children).join('');
                    return /*#__PURE__*/ React.createElement(HtmlComponent, _object_spread({
                        htmlContent: htmlContent
                    }, rest));
                }
                return /*#__PURE__*/ React.createElement("div", {
                    dangerouslySetInnerHTML: {
                        __html: props.children
                    }
                });
            }
        };
        var rehypeOptions = {
            Fragment: Fragment,
            jsx: jsx,
            jsxs: jsxs,
            components: componentMap
        };
        console.log('🔍 [MarkdownRenderer] Creating unified processor...');
        var processor = unified().use(remarkParse).use(remarkDirective) // directive 지원 (:::
        .use(function() {
            console.log('🔍 [MarkdownRenderer] remarkVideoPlugin wrapper executing...');
            return remarkVideoPlugin();
        }) // 비디오 플러그인 with debugging
        .use(remarkGfm) // GitHub Flavored Markdown support
        .use(remarkRehype, {
            allowDangerousHtml: true
        }).use(rehypeRaw) // HTML 태그 지원
        .use(rehypeReact, rehypeOptions);
        console.log('🔍 [MarkdownRenderer] Processor created with plugins:', processor.data());
        return processor;
    }, [
        onQuizSubmit
    ]);
    // 마크다운 렌더링
    var processedContent = useMemo(function() {
        if (!markdownContent) return null;
        console.log('🔍 [MarkdownRenderer] Processing markdown:', {
            markdown: markdownContent.substring(0, 200) + '...',
            hasVideoDirective: markdownContent.includes(':::video'),
            hasContainerDirective: markdownContent.includes('::'),
            processor: !!processor
        });
        try {
            var result = processor.processSync(markdownContent).result;
            console.log('🔍 [MarkdownRenderer] Processing result:', {
                result: result,
                type: typeof result === "undefined" ? "undefined" : _type_of(result)
            });
            return result;
        } catch (error) {
            console.error('🔍 [MarkdownRenderer] Processing error:', error);
            return /*#__PURE__*/ React.createElement("div", {
                style: {
                    color: 'red'
                }
            }, "마크다운 처리 중 오류가 발생했습니다: ", error.message);
        }
    }, [
        markdownContent,
        processor
    ]);
    return /*#__PURE__*/ React.createElement(MarkdownWrapper, {
        className: className,
        "data-testid": testId,
        customFontSize: style === null || style === void 0 ? void 0 : style.fontSize,
        style: style
    }, processedContent || /*#__PURE__*/ React.createElement("p", null, "내용이 없습니다."));
};
export { MarkdownRenderer };
export default MarkdownRenderer;
